// 登录页路由
import Layout from '@/layout/auth' // qwLayout
export default {
  path: '/auth',
  component: Layout,
  name: '登录',
  children: [
    {
      path: '/auth/login',
      component: () => import(/* webpackChunkName: "auth-login" */ '@/view/auth/login'),
      meta: {
        auth: false
      },
      name: '授权-登录'
    },
    {
      path: '/auth/phoneLogin',
      component: () => import(/* webpackChunkName: "auth-login" */ '@/view/auth/phoneLogin'),
      meta: {
        auth: false
      },
      name: '手机-登录'
    }
  ]
}
